import { TextButton } from '@wix/design-system';
import React from 'react';
import { useCurrentModule } from '../../ModuleProvider';
import { getTranslationTags } from '../getTranslationTags';
const AI_CREDITS_URL = 'https://support.wix.com/article/about-ai-credits';
export const SelectPlanDisclaimer = function (_temp) {
  var _taxStatus$data;
  let {
    isMobile
  } = _temp === void 0 ? {} : _temp;
  const module = useCurrentModule();
  const {
    Trans
  } = module.internals.useTranslations();
  const {
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  const taxStatus = module.SDK.eclipseOfferingApiClient.hooks.useFetchTaxStatus({});
  const isAiFeaturesEnabled = experiments.isEnabled('specs.premium.AICreditsWallet');
  const translationTags = getTranslationTags({
    isMobile
  });
  const regularDisclaimer = ((_taxStatus$data = taxStatus.data) == null ? void 0 : _taxStatus$data.treatment) === 'INCLUSIVE' ? /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "page_footer.plans_disclaimer_no_vat",
    components: translationTags
  }) : /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "page_footer.plans_disclaimer_applicable_tax",
    components: translationTags
  });
  if (!isAiFeaturesEnabled) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, regularDisclaimer);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, regularDisclaimer, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "premium-purchase-plan.package_picker.disclaimer.ai_features"
  }), /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "premium-purchase-plan.package_picker.disclaimer.ai_usage",
    components: {
      1: isMobile ? /*#__PURE__*/React.createElement(TextButton, {
        size: "tiny",
        weight: "normal",
        skin: "dark",
        underline: "always",
        as: "a",
        href: AI_CREDITS_URL,
        target: "_blank"
      }) : /*#__PURE__*/React.createElement(TextButton, {
        size: "tiny",
        weight: "thin",
        as: "a",
        href: AI_CREDITS_URL,
        target: "_blank"
      })
    }
  }));
};
//# sourceMappingURL=SelectPlanDisclaimer.js.map